import ArrowBold from './ArrowBold';

export default ArrowBold;
